import React from 'react';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import SecondaryButton from '../../../../../Elements/ids/Buttons/SecondaryButton';
import { employerInfoFormId } from '../EmployerInfo';
import ModalPrimaryButton from '../../../../../Elements/ids/Buttons/ModalPrimaryButton';

const EmployerInfoButtons = ({ closeView, canSubmit }) => {
  return (
    <>
      <SecondaryButton text={formatMessage(Messages.common_cancel)} onClickEvent={closeView} />
      <ModalPrimaryButton
        formId={employerInfoFormId}
        text={formatMessage(Messages.common_save)}
        canSubmit={canSubmit}
      />
    </>
  );
};

export default EmployerInfoButtons;
